// extracted by mini-css-extract-plugin
export var additionalText = "style-mod--additional-text--d333b";
export var body = "style-mod--body--9bff0";
export var container = "style-mod--container--9120f";
export var discount = "style-mod--discount--a4b52";
export var discountContainer = "style-mod--discount-container--33abc";
export var filledProgressLine = "style-mod--filled-progress-line--25ffc";
export var point = "style-mod--point--d098d";
export var points = "style-mod--points--f3ed5";
export var pointsContainer = "style-mod--points-container--0d374";
export var price = "style-mod--price--ddba4";
export var priceContainer = "style-mod--price-container--25665";
export var progress = "style-mod--progress--f089b";
export var progressBar = "style-mod--progress-bar--ff69d";
export var progressBarBody = "style-mod--progress-bar-body--54d79";
export var progressBarMessage = "style-mod--progress-bar-message--1c282";
export var progressLine = "style-mod--progress-line--59460";
export var progressLineBody = "style-mod--progress-line-body--4a321";
export var reminderText = "style-mod--reminder-text--bc7d4";
export var text = "style-mod--text--db4fa";